import { Dialog, withStyles } from '@material-ui/core';

// export const DialogWithCustomStyles = createDialogWithCustomStyles('#FFFFFF');
interface ICustomStyleProp {
  [key: string]: any;
}

// use CSS rules listed in https://mui.com/material-ui/api/dialog/ for the key, eg. paperWidthMd
export function createDialogWithCustomStyles(customStyles: ICustomStyleProp): any {
  return withStyles({
    ...customStyles,
  })(Dialog);
}
